const home: Record<string, string> = {
  'hero.title1': 'YOYBUY Spreadsheet',
  'hero.title2': 'Лучшие товары',
  'hero.title3': 'из Китая 2026',
  'hero.subtitle': 'Curated подборки товаров через YOYBUY агента. Экономьте деньги и находите лучшие предложения из Китая с нашими готовыми spreadsheet таблицами.',
  'hero.ctaSpreadsheet': 'Открыть Spreadsheet',
  'hero.ctaCategories': 'Смотреть категории',
  'categories.title': 'Категории товаров',
  'categories.subtitle': '14 категорий',
  'categories.description': 'Выбирайте из 14 тщательно отобранных категорий товаров. Каждая категория ведёт к проверенным spreadsheet подборкам на kaspreadsheet.com.',
  'featured.title': 'Популярные находки',
  'featured.subtitle': 'Трендовые товары этой недели',
  'about.title1': 'YOYBUY Sheet',
  'about.title2': 'Полное руководство',
  'about.title3': 'по шопингу 2026',
  'about.summary': 'Узнайте, как использовать YOYBUY spreadsheet для поиска лучших товаров из Китая. Пошаговое руководство по сравнению цен, выбору агентов и созданию собственных подборок.',
  'about.cta': 'Читать статью →',
  'about.tag': 'SEO статьи',
  'testimonial.text': '«YOYBUY Finds полностью изменил мой подход к покупкам из Китая. Готовые spreadsheet подборки экономят часы поиска, а качество товаров всегда на высоте. Рекомендую всем, кто хочет покупать умнее.»',
  'testimonial.name': 'Анна К.',
  'testimonial.role': 'Постоянный покупатель YOYBUY',
  'testimonial.cta': 'Перейти к покупкам',
  'finalCta.title': 'НАЧНИТЕ ПОКУПАТЬ УМНЕЕ',
  'finalCta.subtitle': 'Откройте лучшие spreadsheet подборки и найдите идеальные товары из Китая уже сегодня',
  'finalCta.button': 'ПЕРЕЙТИ В МАГАЗИН',
  'why.title': 'Почему YOYBUY Spreadsheet?',
  'why.item1.title': 'Проверенные товары',
  'why.item1.desc': 'Каждый товар в наших подборках тщательно проверен на качество и соответствие описанию',
  'why.item2.title': 'Еженедельные обновления',
  'why.item2.desc': 'Spreadsheet таблицы обновляются каждую неделю, чтобы вы всегда находили актуальные находки',
  'why.item3.title': 'Сравнение цен',
  'why.item3.desc': 'Мы сравниваем цены между разными агентами, помогая вам экономить до 30%',
  'why.item4.title': 'Только лучшее',
  'why.item4.desc': 'Никакого мусора — только проверенные находки с высокими оценками и отзывами',
};

export default home;